import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./modules/components/Header";
import Home from "./modules/Home";
import Redirect from "./modules/components/Redirect";
import "./App.css";
import CodigoConducta from "./modules/codigo-conducta/CodigoConducta";
import Programacion from "./modules/programacion/Programacion";
import InfoPractica from "./modules/informacion-practica/InfoPractica";
import Galeria from "./modules/galeria/Galeria";

function App() {
  return (
    <Router>
      <div className="min-h-screen relative bg-jakala-dark-blue">
        <a
          href="#contenido-principal"
          className="absolute left-4 top-4 z-[100] -translate-y-[200%] bg-white text-Colors-blue-dark px-4 py-2 rounded font-semibold focus:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-Colors-blue-dark"
        >
          Saltar al contenido principal
        </a>
        <div className="relative z-20">
          <Header />
          <main id="contenido-principal" tabIndex={-1} className="outline-none">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/agenda" element={<Programacion />} />
              <Route path="/informacion-practica" element={<InfoPractica />} />
              <Route
                path="/propuesta-de-charlas"
                element={<Redirect to="https://charlas-open-space.jakala.es" />}
              />
              <Route path="/codigo-conducta" element={<CodigoConducta />} />
              <Route path="/galeria" element={<Galeria />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
